import {ReportModel} from "@fedeltapointofsale/data-client";
import {AccSingleInvReportData} from "./acc-single-inv-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class AccSingleInvReportModel extends ReportModel<AccSingleInvReportData> {
    constructor(injector: Injector) {
        super(injector, AccSingleInvReportData)
    }
}
